(function () {
  function closestSection(node) {
    return node && node.closest ? node.closest('.tatpub-vi03__section') : null;
  }

  function setText(node, value) {
    if (node) node.textContent = value;
  }

  function injectCompressionStyles() {
    if (document.getElementById('tatpub-ui-compression-runtime-css')) return;
    var style = document.createElement('style');
    style.id = 'tatpub-ui-compression-runtime-css';
    style.textContent = [
      '.tatpub-vi03--runtime-compressed .tatpub-vi03__answer{display:none!important}',
      '.tatpub-vi03--runtime-compressed .tatpub-ritual-card ul{display:none!important}',
      '.tatpub-vi03--runtime-compressed .tatpub-vi03__section[data-runtime-hidden]{display:none!important}',
      '.tatpub-vi03--runtime-compressed .tatpub-care-grid{display:none!important}',
      '.tatpub-vi03--runtime-compressed .tatpub-material-grid .tatpub-material-tile:nth-child(n+5){display:none!important}',
      '.tatpub-vi03--runtime-compressed .tatpub-ritual-card__body p:not(.tatpub-vi03__eyebrow){font-size:1.5rem;line-height:1.55}',
      '.tatpub-vi03--runtime-compressed .tatpub-ritual-card__body h3{font-size:clamp(2rem,2.2vw,3.2rem)}',
      '.tatpub-vi03--runtime-compressed .tatpub-vi03__hero-copy{max-width:62rem}',
      '.tatpub-vi03--runtime-compressed .tatpub-service-links{display:flex;flex-wrap:wrap;gap:1rem 1.6rem;margin-top:2.2rem;padding-top:2rem;border-top:1px solid rgba(242,237,230,.2)}',
      '.tatpub-vi03--runtime-compressed .tatpub-service-links a{color:rgba(242,237,230,.78);font-size:1.15rem;font-weight:800;letter-spacing:.1em;text-decoration:none;text-transform:uppercase}',
      '@media(max-width:599px){.tatpub-site-header__nav a:nth-child(4),.tatpub-site-header__nav a:nth-child(5){display:none!important}.tatpub-vi03--runtime-compressed .tatpub-ritual-grid,.tatpub-vi03--runtime-compressed .tatpub-vi03__journal-grid{display:flex;overflow-x:auto;scroll-snap-type:x mandatory}.tatpub-vi03--runtime-compressed .tatpub-ritual-grid>*,.tatpub-vi03--runtime-compressed .tatpub-vi03__journal-grid>*{flex:0 0 86%;scroll-snap-align:start}}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function patchHomepageCompression() {
    if (window.location.pathname !== '/') return;
    var home = document.querySelector('[data-tatpub-vi03-home]');
    if (!home || home.classList.contains('tatpub-vi03--compressed')) return;

    injectCompressionStyles();
    home.classList.add('tatpub-vi03--runtime-compressed');

    setText(home.querySelector('.tatpub-vi03__hero-content .tatpub-vi03__eyebrow'), 'Architectural Hosting System');
    setText(home.querySelector('.tatpub-vi03__hero-content h1'), 'TATPUB Hosting System \u2014 Edition 01');
    setText(
      home.querySelector('.tatpub-vi03__hero-copy'),
      'A sculptural hosting object for match nights, private evenings, and composed gatherings.'
    );

    var answerSection = closestSection(home.querySelector('.tatpub-vi03__answer'));
    if (answerSection) answerSection.setAttribute('data-runtime-hidden', 'true');

    var editionSection = closestSection(home.querySelector('.tatpub-edition-card'));
    if (editionSection) editionSection.setAttribute('data-runtime-hidden', 'true');

    var careSection = closestSection(home.querySelector('.tatpub-care-grid'));
    if (careSection) careSection.setAttribute('data-runtime-hidden', 'true');

    var ritualHeader = home.querySelector('.tatpub-ritual-grid');
    if (ritualHeader) {
      var ritualSection = closestSection(ritualHeader);
      setText(ritualSection && ritualSection.querySelector('.tatpub-vi03__header .tatpub-vi03__eyebrow'), 'Rituals');
      setText(ritualSection && ritualSection.querySelector('.tatpub-vi03__header h2'), 'Three Rituals of Hosting');
      setText(ritualSection && ritualSection.querySelector('.tatpub-vi03__header p:not(.tatpub-vi03__eyebrow)'), 'One system, composed for different evenings.');
    }

    var cards = home.querySelectorAll('.tatpub-ritual-card');
    var rituals = [
      {
        eyebrow: 'Match Night',
        title: 'Chilled bottles, cut crystal, citrus, and small bites arranged before the first pour.',
        cta: 'View Match Night',
        href: '/pages/match-night-hosting',
      },
      {
        eyebrow: 'Private Evening',
        title: 'A quieter service moment for champagne, glassware, candlelight, and conversation.',
        cta: 'View Private Evening',
        href: '/products/tatpub-hosting-system-edition-01#complete-hosting-system',
      },
      {
        eyebrow: 'Social Gathering',
        title: 'A self-serve hosting point that keeps the room moving without breaking the conversation.',
        cta: 'View Social Gathering',
        href: '/products/tatpub-hosting-system-edition-01#complete-hosting-system',
      },
    ];
    cards.forEach(function (card, index) {
      var data = rituals[index];
      if (!data) return;
      setText(card.querySelector('.tatpub-vi03__eyebrow'), data.eyebrow);
      setText(card.querySelector('h3'), data.title);
      var bodyCopy = card.querySelector('.tatpub-ritual-card__body p:not(.tatpub-vi03__eyebrow)');
      if (bodyCopy) bodyCopy.remove();
      var media = card.querySelector('.tatpub-ritual-card__media');
      if (media) media.setAttribute('href', data.href);
      var cta = card.querySelector('.tatpub-vi03__button');
      if (cta) {
        cta.classList.remove('tatpub-vi03__button--ritual');
        cta.classList.add('tatpub-vi03__text-link');
        cta.textContent = data.cta;
        cta.setAttribute('href', data.href);
      }
    });

    var materialSection = closestSection(Array.from(home.querySelectorAll('.tatpub-vi03__header h2')).find(function (node) {
      return node.textContent.indexOf('Every surface has a role') !== -1;
    }));
    if (materialSection) {
      setText(materialSection.querySelector('.tatpub-vi03__header .tatpub-vi03__eyebrow'), 'Material Architecture');
      setText(materialSection.querySelector('.tatpub-vi03__header h2'), 'Material Architecture');
      setText(
        materialSection.querySelector('.tatpub-vi03__header p:not(.tatpub-vi03__eyebrow)'),
        'Marble creates ceremony. Brass gives the object structure. Glass keeps the silhouette light. Teak brings warmth back into the room.'
      );
      var materialTiles = materialSection.querySelectorAll('.tatpub-material-tile');
      [
        ['Marble', 'Ceremony'],
        ['Hammered Brass', 'Structure'],
        ['Tempered Glass', 'Lightness'],
        ['Teak Warmth', 'Balance'],
      ].forEach(function (pair, index) {
        var tile = materialTiles[index];
        if (!tile) return;
        setText(tile.querySelector('b'), pair[0]);
        setText(tile.querySelector('span'), pair[1]);
      });
      if (!materialSection.querySelector('[data-runtime-craft-link]')) {
        var craftLink = document.createElement('a');
        craftLink.className = 'tatpub-vi03__button tatpub-vi03__button--secondary tatpub-vi03__section-cta';
        craftLink.href = '/pages/craft';
        craftLink.textContent = 'Explore Craft';
        craftLink.setAttribute('data-runtime-craft-link', '');
        materialSection.querySelector('.tatpub-vi03__container').appendChild(craftLink);
      }
    }

    var roomSection = closestSection(Array.from(home.querySelectorAll('.tatpub-vi03__header h2, .tatpub-vi03__split h2')).find(function (node) {
      return node.textContent.indexOf('Not sure where it belongs') !== -1;
    }));
    if (roomSection && !roomSection.querySelector('.tatpub-service-links')) {
      var nav = document.createElement('nav');
      nav.className = 'tatpub-service-links';
      nav.setAttribute('aria-label', 'Client care links');
      nav.innerHTML = [
        '<a href="/pages/client-care#delivery">Delivery &amp; Handling</a>',
        '<a href="/pages/client-care#returns">Returns &amp; Evaluation</a>',
        '<a href="/pages/client-care#secure-checkout">Secure Checkout</a>',
        '<a href="/pages/design-consultation">Room Fit Support</a>',
      ].join('');
      var roomCopy = roomSection.querySelector('.tatpub-vi03__actions');
      if (roomCopy) roomCopy.insertAdjacentElement('afterend', nav);
    }

    var journalSection = closestSection(Array.from(home.querySelectorAll('.tatpub-vi03__split h2')).find(function (node) {
      return node.textContent.indexOf('Design notes for elevated evenings') !== -1;
    }));
    if (journalSection) {
      setText(journalSection.querySelector('.tatpub-vi03__eyebrow'), 'Hosting Journal');
      setText(journalSection.querySelector('h2'), 'Hosting Journal');
      setText(
        journalSection.querySelector('p:not(.tatpub-vi03__eyebrow)'),
        'Design notes for elevated evenings, material-led interiors, and modern home entertaining.'
      );
    }
  }

  function patchSupportExperience() {
    var roomFitReplacement =
      'To share room photos, email them to <a href="mailto:support@tatpub.com?subject=Room%20Fit%20Review%20Request%20-%20TATPUB">support@tatpub.com</a> after submitting the consultation request with the subject "Room Fit Review".';

    document.querySelectorAll('.shopify-section-group-header-group [data-tatpub-global-footer], .shopify-section-group-header-group .tatpub-footer').forEach(function (footer) {
      footer.remove();
    });

    document.querySelectorAll('[data-tatpub-global-footer]').forEach(function (footer) {
      if (!footer.closest('.shopify-section-group-footer-group')) footer.remove();
    });

    document.querySelectorAll('p, li, div').forEach(function (node) {
      if (node.children.length > 2) return;
      if (node.textContent.indexOf('OWNER_INPUT_REQUIRED: branded support email needed') !== -1) {
        node.innerHTML = roomFitReplacement;
      }
    });

    if (window.location.pathname === '/cart' && !document.querySelector('[data-tatpub-support-line]')) {
      var cartTarget = document.querySelector('.cart__footer') || document.querySelector('main');
      if (cartTarget) {
        var cartLine = document.createElement('p');
        cartLine.className = 'tatpub-client-care-support-line';
        cartLine.setAttribute('data-tatpub-support-line', '');
        cartLine.innerHTML =
          'Questions before checkout? Contact Client Care at <a href="mailto:support@tatpub.com?subject=Checkout%20Question%20-%20TATPUB">support@tatpub.com</a>.';
        cartTarget.appendChild(cartLine);
      }
    }
  }

  function formatMoneyFromCents(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function productCardHtml(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var href = '/products/' + product.handle;
    var title = product.title || product.handle;
    return [
      '<article class="tatpub-accessory-setup-card">',
      '<a class="tatpub-accessory-setup-card__media" href="' + href + '">',
      image ? '<img loading="lazy" src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '">' : '',
      '</a>',
      '<div class="tatpub-accessory-setup-card__body">',
      '<h3><a href="' + href + '">' + title + '</a></h3>',
      '<p class="tatpub-accessory-setup-card__price">' + formatMoneyFromCents(product.price || product.price_min) + '</p>',
      '<a class="tatpub-accessory-setup-card__link" href="' + href + '">View product</a>',
      '</div>',
      '</article>',
    ].join('');
  }

  function patchAccessorySetupFallback() {
    var currentHandle = (window.location.pathname.match(/^\/products\/([^/?#]+)/) || [])[1];
    var accessoryHandles = [
      'tatpub-carrara-coaster-set',
      'tatpub-hammered-brass-ice-bucket',
      'tatpub-fsc-teak-serving-tray',
      'tatpub-how-to-host-card-set',
    ];
    if (accessoryHandles.indexOf(currentHandle) === -1) return;
    if (document.querySelector('.tatpub-accessory-complete-setup .tatpub-accessory-setup-card')) return;

    var target = document.querySelector('product-recommendations.related-products');
    if (!target || target.getAttribute('data-tatpub-setup-fallback') === 'ready') return;
    if (target.getAttribute('data-tatpub-setup-fallback') === 'loading') return;

    var setupHandles = [
      'tatpub-hosting-system-edition-01',
      'tatpub-how-to-host-card-set',
      'tatpub-carrara-coaster-set',
      'tatpub-fsc-teak-serving-tray',
      'tatpub-hammered-brass-ice-bucket',
    ]
      .filter(function (handle) {
        return handle !== currentHandle;
      })
      .slice(0, 3);

    target.setAttribute('data-tatpub-setup-fallback', 'loading');
    Promise.all(
      setupHandles.map(function (handle) {
        return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Product JSON unavailable');
            return response.json();
          });
      })
    )
      .then(function (products) {
        if (document.querySelector('.tatpub-accessory-complete-setup .tatpub-accessory-setup-card')) return;
        target.innerHTML = [
          '<h2 class="tatpub-accessory-pdp__heading">Complete the setup</h2>',
          '<div class="tatpub-accessory-setup-list">',
          products.map(productCardHtml).join(''),
          '</div>',
        ].join('');
        target.setAttribute('data-tatpub-setup-fallback', 'ready');
      })
      .catch(function () {
        target.removeAttribute('data-tatpub-setup-fallback');
      });
  }

  function run() {
    patchHomepageCompression();
    patchSupportExperience();
    patchAccessorySetupFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  setTimeout(run, 250);
  setTimeout(run, 1000);
  setTimeout(run, 2500);
  setTimeout(run, 5000);
})();
